import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getOrderGeneratorsFieldsWorks(companyId) {
	return dataTransferWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS,
		dtConfig[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS].getOrderGeneratorsFieldsWorks,
		{
			urlParams: {
				companyId,
			},
		}
	)
}

function getOrderGeneratorsFieldsWork(companyId, fieldWorkId) {
	return dataTransferWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS,
		dtConfig[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS].getOrderGeneratorsFieldsWork,
		{
			urlParams: {
				companyId,
				fieldWorkId,
			},
		}
	)
}

function createOrderGeneratorsFieldsWork(companyId, payload) {
	return dataTransferWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS,
		dtConfig[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS].createOrderGeneratorsFieldsWork,
		{
			urlParams: {
				companyId,
			},
			...payload,
		}
	)
}


function putOrderGeneratorsFieldsWork(companyId, fieldWorkId, payload) {
	return dataTransferWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS,
		dtConfig[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS].putOrderGeneratorsFieldsWork,
		{
			urlParams: {
				companyId,
				fieldWorkId,
			},
			...payload,
		}
	)
}

function patchOrderGeneratorsFieldsWork(companyId, fieldWorkId, payload) {
	return dataTransferWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS,
		dtConfig[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS].patchOrderGeneratorsFieldsWork,
		{
			urlParams: {
				companyId,
				fieldWorkId,
			},
			...payload,
		}
	)
}

function deleteOrderGeneratorsFieldsWork(companyId, fieldWorkId) {
	return dataTransferWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS,
		dtConfig[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS].deleteOrderGeneratorsFieldsWork,
		{
			urlParams: {
				companyId,
				fieldWorkId,
			},
		}
	)
}

function getOrderGeneratorsFieldsWorkPreview(companyId, fieldWorkId) {
	return dataTransferWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS,
		dtConfig[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS].getOrderGeneratorsFieldsWorkPreview,
		{
			urlParams: {
				companyId,
				fieldWorkId,
			},
		}
	)
}

function getOrderGeneratorsFieldsWorkPopup(companyId, fieldWorkId) {
	return dataTransferWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS,
		dtConfig[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS].getOrderGeneratorsFieldsWorkPopup,
		{
			urlParams: {
				companyId,
				fieldWorkId,
			},
		}
	)
}

function getOrderGeneratorsFieldsWorkRelatedPlanWorks(companyId, generatorId) {
	return dataTransferWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS,
		dtConfig[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS].getOrderGeneratorsFieldsWorkRelatedPlanWorks,
		{
			urlParams: {
				companyId,
				generatorId,
			},
		}
	)
}

export default {
	getOrderGeneratorsFieldsWorks,
	getOrderGeneratorsFieldsWork,
	createOrderGeneratorsFieldsWork,
	putOrderGeneratorsFieldsWork,
	patchOrderGeneratorsFieldsWork,
	deleteOrderGeneratorsFieldsWork,
	getOrderGeneratorsFieldsWorkPreview,
	getOrderGeneratorsFieldsWorkPopup,
	getOrderGeneratorsFieldsWorkRelatedPlanWorks
}

